<div class="di-btn-facture-preparee">
	<lua-papier mode="outlined" [fullWidth]="true" [selected]="selected" [selectionnable]="true">
		<div class="bfp-content">
      <div class="content-start">
        <lua-icone iconName="task" mode="outlined" color="CouleurPrimaire" fontSize="20px"></lua-icone>
        <strong>Factures préparées</strong>
      </div>            
      <lua-tag class="bfp-tag" color="Blanc" [label]="invoiceCount"></lua-tag>
		</div>
	</lua-papier>
</div>